// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__grAlV {
  grid-area: header;
  display: grid;
  grid-template: "a11yMenu" auto "menu" auto "breadcrumbs" auto "systemStatus" auto/1fr;
}
.Header_header__grAlV ul,
.Header_header__grAlV ol {
  list-style: none;
  margin: 0;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/views/Template/components/Menu/Header.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,qFACE;AAAJ;AAKE;;EAEE,gBAAA;EACA,SAAA;EACA,UAAA;AAHJ","sourcesContent":[".header {\n  grid-area: header;\n  display: grid;\n  grid-template:\n    \"a11yMenu\" auto\n    \"menu\" auto\n    \"breadcrumbs\" auto\n    \"systemStatus\" auto\n    / 1fr;\n  ul,\n  ol {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__grAlV`
};
export default ___CSS_LOADER_EXPORT___;
